import Header from '../componentes/Header';
import LanguageSwitcher from '../componentes/LanguageSwitcher';
import Splash from '../componentes/Splash';
import SchedulingPolicy from '../componentes/SchedulingPolicy';
import FibraVidro from '../componentes/FibraVidro';
import BanhoGel from '../componentes/BanhoGel';
import Photos from '../componentes/Photos';
import Rodape from '../componentes/Rodape';
import * as S from './styles';

function Home() {
  return (
    <S.Container id="top">
      <LanguageSwitcher />
      <Header />
      <Splash />
      <main>
        <SchedulingPolicy />
        <FibraVidro />
        <Photos />
        <BanhoGel />
      </main>
      <Rodape />
    </S.Container>
  );
}

export default Home;
